import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    title: 'El Protocolo 5-5-5',
    desc: 'La técnica paso a paso para detener la crisis en menos de 5 minutos.'
  }, {
    title: 'El Escaneo 3D',
    desc: 'Cómo usar el entorno para sacar a tu hijo de su cabeza y traerlo de vuelta a la realidad.'
  }, {
    title: 'El Manual de Etiquetado',
    desc: "Las frases exactas para quitarle el poder al 'Monstruo' de la ansiedad."
  }, {
    title: 'Guía de Recuperación Post-Ataque',
    desc: 'Qué hacer en la hora siguiente para evitar que el ataque regrese.'
  }, {
    title: "Checklist de 'Falsas Alarmas'",
    desc: 'Para que identifiquen juntos que los síntomas físicos no son peligrosos.'
  }];
  return <section className="w-full bg-cream py-20 md:py-28 px-6" data-id="element-206">
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <FadeIn data-id="element-208">
          <h2 className="text-3xl md:text-5xl font-serif text-slate-900 text-center mb-16" data-id="element-209">
            ¿Qué Incluye la Guía?
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-210">
          {features.map((feature, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-211">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100 flex items-start gap-5 hover:shadow-md transition-shadow" data-id="element-212">
                <div className="flex-shrink-0 mt-1" data-id="element-213">
                  <CheckCircle2 className="w-8 h-8 text-sage-dark" data-id="element-214" />
                </div>
                <div data-id="element-215">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-216">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600 text-lg" data-id="element-217">{feature.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}